import { GET_TRANSACTION_MESSAGE } from './../constants';
import { handleActions } from "redux-actions"

export const alert  = handleActions(
  {
    [ GET_TRANSACTION_MESSAGE ]: (state, action) => action.payload
  }, {}
)